import { Modal, Text } from '@cinch-labs/design-system'
import styles from './range-estimation-desktop.module.css'
import { RangeEstimationContent } from '../range-estimation-content/range-estimation-content'

export interface RangeEstimationDesktopProps {
  content: RangeEstimationContent
  onClose: () => void
}

export const RangeEstimationDesktop = ({
  content,
  onClose,
}: RangeEstimationDesktopProps) => (
  <Modal
    title={content.title}
    titleId="range-estimation-title"
    onClose={onClose}
  >
    {content.type === 'nedc' || content.type === 'wltp' ? (
      // WLTP/NEDC structure: boldText, description, footer
      <>
        <Text className={styles.boldText}>{content.boldText}</Text>
        <Text className={styles.descriptionText}>{content.description}</Text>
        <Text fontSizeFixed="xs" className={styles.footerText}>
          {content.footer}
        </Text>
      </>
    ) : (
      // Default structure: two paragraphs
      <>
        <Text style={{ marginBottom: '32px' }}>{content.paragraph1}</Text>
        <Text>{content.paragraph2}</Text>
      </>
    )}
  </Modal>
)
